import api from './api'; // Import the authenticated API client

export interface DashboardStats {
  totalCalls: number;
  previousTotalCalls: number;
  completedCalls: number;
  previousCompletedCalls: number;
  performanceScore: number;
  previousPerformanceScore: number;
  activeCalls: number;
}

export const getDashboardStats = async (startDate: string, endDate: string): Promise<DashboardStats> => {
  const response = await api.get<DashboardStats>('/api/dashboard/stats', {
    params: {
      startDate,
      endDate
    }
  });
  return response.data;
};

// Onboarding Progress API
export interface OnboardingTaskState {
  completed: boolean;
  completed_at?: string;
  user_override?: 'complete' | 'skipped' | null;
}

export interface OnboardingProgress {
  onboarding: {
    [taskId: string]: OnboardingTaskState;
  };
  last_updated?: string;
  version?: number;
}

export const getOnboardingProgress = async (): Promise<OnboardingProgress> => {
  const response = await api.get<{ onboarding_progress: OnboardingProgress }>(
    '/account/user/settings/onboarding'
  );
  // If onboarding_progress is missing, return an empty onboarding object
  return response.data.onboarding_progress || { onboarding: {} };
};

export const updateOnboardingProgress = async (progress: OnboardingProgress): Promise<OnboardingProgress> => {
  const response = await api.put<{ onboarding_progress: OnboardingProgress }>(
    '/account/user/settings/onboarding',
    { onboarding_progress: progress }
  );
  return response.data.onboarding_progress;
}; 